module.exports = require("path");


//////////////////
// WEBPACK FOOTER
// external "path"
// module id = 199
// module chunks = 0